// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__IjR4X","productName":"Table_productName__3pPY5"};